/* 曹操傳・第 9 章：白狼山（建安十二年，207）
 * 史實：《三國志·武帝紀》曹操北征烏桓，出盧龍塞，「塹山堙谷五百餘里」，「登白狼山，卒與虜遇，衆甚盛……公登高，望虜陳不整，
 *       乃縱兵擊之，使張遼爲先鋒，虜衆大崩，斬蹋頓及名王已下」。
 * 流程：操作張遼。1. 長途行軍：軍糧一直在減，沿路撿糧袋、水囊補充；斷糧時部下會開始掉血。
 *       2. 登上白狼山頂，望見烏桓大軍正在列陣（陣形值一直上升）。趁陣形還沒整好衝下去，虜眾大崩；斬蹋頓即勝利。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, boss, PEOPLE, TROOPS, troop, rout } from '../kit.ts';
import { HILL, TADUN, SUPPLY } from '../maps/bailang.ts';

const LV = 13, START = [1100, 4300], FORM_T = 45;
const WUHUAN = troop('wuhuan-rider', '烏桓騎', { armor: '#6a6a7a', sleeve: '#4a4a5a', cloth: '#4a4a5a', plume: '#a0a0b0' });
const FOE = { spec: WUHUAN, name: '烏桓騎', hp: 460, maxHp: 460, atk: 28, ms: 260 };

export default {
  id: 'caocao-9', map: 'bailang', hero: 'zhangliao',
  title: '第 9 章　白狼山', year: '建安十二年（207）',
  brief: {
    quote: [{ text: '登白狼山，卒與虜遇，衆甚盛。', src: '《三國志·魏書·武帝紀》' }],
    text: '袁紹的兒子袁尚、袁熙逃到烏桓，曹操北征。郭嘉建議輕兵兼道而進。大軍出盧龍塞，在山谷裡開路五百餘里。',
    goals: ['沿路補充軍糧，走到白狼山', '登上山頂，趁烏桓還沒列好陣衝下去', '斬蹋頓'],
  },
  words: { ally: '曹軍', foe: '烏桓騎' },
  stars: [
    { text: '行軍途中一次也沒斷糧', ok: (m) => !m.vars.starved },
    { text: '如史：趁陣形不到一半就衝下去', ok: (m) => m.vars.formAt != null && m.vars.formAt < 50 },
    { text: '曹軍折損不超過 5 人', ok: (m) => m.stats.lost <= 5 },
  ],
  steps: [
    { // 1. 長途行軍
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = START[0]; me.y = START[1];
        V.food = 100;
        V.men = Array.from({ length: 10 }, (_, i) => { const u = m.recruit(me.x - 80 - (i % 5) * 45, me.y - 50 + Math.floor(i / 5) * 90, '曹騎'); u.spec = TROOPS.wei; u.ms = 300; m.join(u, me); return u; });
        V.sup = SUPPLY.map(([x, y], k) => m.loot(x, y, 'food', { n: 0.2, name: k % 2 ? '水囊' : '糧袋', supply: true }));
        m.card('塹山堙谷五百餘里。', '《武帝紀》');
        m.line('張遼', '山路難走，糧草要省著用。沿路有百姓留下的糧袋、水囊，撿起來。');
        m.after(4, () => m.line('提示', '軍糧一直在減；撿到糧袋、水囊就補回來。斷糧時部下會開始掉血。'));
        m.obj('food', '');
        m.mark('hill', HILL[0], HILL[1], '白狼山');
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars;
        V.food = Math.max(0, V.food - dt * 2.4);
        for (const l of V.sup) if (l.got && !l.counted) { l.counted = true; V.food = Math.min(100, V.food + 35); }
        if (V.food <= 0) { V.starved = true; for (const u of m.alive(V.men).concat(me)) u.hp -= u.maxHp * 0.02 * dt; }
        m.get('food').text = `軍糧：${Math.round(V.food)}%`;
        return m.near(me, HILL[0], HILL[1], 260);
      },
    },
    { // 2. 登高望虜陳不整
      enter(m, w) {
        const V = m.vars;
        m.unmark('hill'); m.drop('food');
        m.card('卒與虜遇，衆甚盛。', '《武帝紀》');
        V.td = boss(w, PEOPLE.yanliang, TADUN[0], TADUN[1], { name: '蹋頓', hp: 3600, atk: 46, armor: 8 });
        V.td.spec = Object.assign({}, PEOPLE.yanliang, { c: Object.assign({}, PEOPLE.yanliang.c, { armor: '#6a6a7a', cape: '#8a8a9a' }) });
        V.horde = [];
        for (let i = 0; i < 22; i++) { const a = (i / 22) * Math.PI * 2, u = m.foe('huangjin', TADUN[0] + Math.cos(a) * (300 + (i % 3) * 120), TADUN[1] + Math.sin(a) * (220 + (i % 3) * 90), FOE); u.home = [u.x, u.y]; V.horde.push(u); }
        V.form = 0; V.t2 = w.t;
        m.after(2, () => m.line('曹操', '虜陳不整！文遠，你為先鋒，衝下去！'));
        m.obj('form', '');
        m.mark('td', V.td.x, V.td.y, '蹋頓', false, V.td);
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars;
        if (V.formAt == null) {
          V.form = Math.min(100, ((w.t - V.t2) / FORM_T) * 100);
          m.get('form').text = `烏桓的陣形：${Math.round(V.form)}%（越整齊越難打）`;
          const hit = V.horde.concat(V.td).some((u) => u.dmgBy && u.dmgBy[me.id] > V.t2);
          if (hit) {
            V.formAt = V.form; m.done('form');
            if (V.form < 50) { m.big('虜眾大崩！'); rout(m, w, m.alive(V.horde).filter((_, i) => i % 3), [9600, 2600]); for (const u of m.alive(V.horde)) w.addBuff(u, { id: '陣亂', t: 15, neg: true, atkP: -0.3, ms: -0.2 }); }
            else { m.line('張遼', '陣形已經列好了……硬衝！'); for (const u of m.alive(V.horde)) w.addBuff(u, { id: '列陣', t: 15, atkP: Math.min(0.4, V.form / 250) }); }
            m.obj('td', '斬蹋頓');
          }
        }
        return !V.td.alive;
      },
    },
    { // 3. 斬蹋頓
      enter(m, w) {
        const V = m.vars;
        m.done('td'); m.unmark('td');
        m.card('使張遼爲先鋒，虜衆大崩，斬蹋頓及名王已下。', '《武帝紀》');
        rout(m, w, V.horde, [9600, 2600]);
        m.after(6, () => m.win());
      },
      tick() { return false; },
    },
  ],
  always(m, w) { if (!w.player.alive) m.lose('張遼陣亡'); },
};
